module.exports = (__webpack_require__(24))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference lib_core
// module id = 72
// module chunks = 106